import React, { Suspense, useState, useEffect } from "react";
import styled from "styled-components";
import { Popover, Tooltip, Typography } from "antd";
import { maxWidth, maxTablet, retina, secondaryFont, primaryHeadingColor, primaryFont, primaryColor, XIQ_ONLINE_URL } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import UserIcon from "./Components/UserIcon";
import { logOut } from "modules/Login/action";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";


const { Paragraph } = Typography;

const ContentWrapper = styled.div`
  max-width: 350px;
  .account-icon {
    margin-right: 10px;
    margin-left: 2px;
  }
  h2 {
    font-size: 24px;
    color:${primaryHeadingColor};
    font-weight: 800;
    font-family: ${secondaryFont};
    letter-spacing: -0.45px;
    line-height: 36.93px !important;
    margin: 0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
    }
  }
  .name {
    font-family: ${secondaryFont};
    font-size: 18px;
    line-height: 20px !important;
    font-weight: 700;
    letter-spacing: -0.45px;
    color: ${primaryHeadingColor};
    margin-bottom: 5px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      margin-bottom: 2px;
    }
  }
  .email {
    font-family: ${primaryFont};
    font-size: 14px;
    line-height: 15px !important;
    font-weight: 500;
    letter-spacing: -0.29px;
    color: ${primaryHeadingColor};
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
  .logout {
    font-family: ${primaryFont};
    color: ${primaryColor};
    font-size: 14px;
    line-height: 15px !important;
    font-weight: 600;
    /* letter-spacing: -0.29px; */
    cursor: pointer;
    margin-bottom: 0px;
  }
  `;

const Wrapper = styled.div`
  display:flex;
  /* margin-right: 40px; */
  @media all and (max-width: ${maxTablet}) {
    margin-right: 0px;
  }
  .ant-popover-placement-rightBottom {
    top: -60px;
  }
  .ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {
    bottom: 25px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      bottom: 25px;
    }
    @media all and (max-height: 786px) {
      bottom: 15px;
    }
  }
  .ant-popover-inner {
    border-radius: 12px;
    padding: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 12px;
    }
  }
  .ant-popover {
    min-width: 295px;
    width: 305px;
    /* handle 1.25% and 1024 screen size */
    @media all and (max-width: ${maxWidth}) , ${retina} {
      min-width: 260px;
      width: 260px;
    }
  }
  .ant-popover-inner-content {
    padding: 15px 25px 5px 25px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 15px 20px 5px 20px;
    }
  }
  .dropdown-user-profile{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: auto;
  }
  .userInfoSection {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0px 15px 0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 5px 0px 10px 0;
    }
  }
  .image-container {
    width: 32%;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 30%;
    }
  }
  .profile {
    width: 68%;
    padding-left: 8px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 70%;
    }
  }
`;

const Image = styled.div<{ image: string; height?: string; width?: string; heightSm?: string; widthSm?: string }>`
 width: ${(props) => props.width ?? "35px"};
 height: ${(props) => props.height ?? "35px"};
 @media all and (max-width: ${maxWidth}) , ${retina} {
  width: ${(props) => props.widthSm ?? "35px"};
  height: ${(props) => props.heightSm ?? "35px"};
}
 border-radius: 50%;
 padding: 2px;
 background-image: url(${(props) => props.image});
 background-position:center;
 background-size:cover;
 background-color: #fff;
`;

const Persona = styled.div<{ border: string; width?: string; height?: string; heightSm?: string; widthSm?: string }>`
 background: conic-gradient(from -70deg, ${(props) => props.border});
 width: ${(props) => props.width ?? "39px"};
 height:  ${(props) => props.height ?? "39px"};
 @media all and (max-width: ${maxWidth}) , ${retina} {
  width: ${(props) => props.widthSm ?? "39px"};
  height: ${(props) => props.heightSm ?? "39px"};
}
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
`;

type Props = {};

const Content = function Content({ image, colors, email, fullName }: { [key: string]: string }) {
  const history = useHistory();
  const dispatch = useDispatch();
  // getting remove method from useCookies
  const [cookies, setCookie, removeCookie] = useCookies([]);

  const handleLogout = () => {
    removeCookie("access_id");
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth();
    let day = now.getDate();
    let cookieExpiry = new Date(year + 1, month, day);
    let domain = ".xiqonline.com";
    if (window.location.hostname === "localhost") {
      domain = "localhost";
    }
    setCookie("isLogout", "1", {
      path: "/",
      expires: cookieExpiry,
      domain: domain,
    });
    localStorage.setItem("isListView", "false");
    logOut().finally(() => {
      localStorage.removeItem("csrfToken");
      dispatch({ type: "USER_LOGOUT" });
      let hostName = window.location.hostname;
      // if not localhost redirect to WebApp - workbench login screen
      if (hostName !== "localhost") {
        window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
      } else {
        history.push(""); // redirect to login page
        window.location.reload();
      }
    });
  };
  return (
    <ContentWrapper>
      <div className="d-flex align-items-center">
        <div
          className="d-flex align-items-center account-icon" >
          <Suspense
            fallback={<div />}
          >
            <UserIcon />
          </Suspense>
        </div>
        <div>
          <h2 className="primary-color text-center">
            Account
          </h2>
        </div>
      </div>
      <div className="userInfoSection">
        <div className="image-container">
          <Persona border={colors} height="72px" width="72px" heightSm="60px" widthSm="60px">
            {image !== '' ? (
              <Image
                className="User_Image"
                image={image}
                height="62px"
                width="62px"
                heightSm="52px"
                widthSm="52px"
              />
            ) : (
              <UserIcon />
            )}
          </Persona>
        </div>
        <div className="profile">
          <Paragraph className="name text-truncate" ellipsis={{ rows: 1, tooltip: fullName }}>
            {fullName ?? ""}
          </Paragraph>

          <Paragraph className="email text-truncate" ellipsis={{ rows: 1, tooltip: email }}>
            {email ?? ""}
          </Paragraph>
          <div>
            <span className="logout" onClick={handleLogout}>
              Logout
            </span>
          </div>
        </div>

      </div>
    </ContentWrapper >
  );
};


function AccountPopover({ }: Props) {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [image, setImage] = useState<string>('');
  const [colors, setColors] = useState<string>('');
  const accountDetails = useSelector((state: RootState) => state.user.accountDetails);
  const userEmail = useSelector((state: RootState) => state.user.userData.user_email);
  const { email, fullName, profilePic, personCard } = accountDetails;



  useEffect(() => {
    if (profilePic) {
      setImage(accountDetails.profilePic);
    };
    if (personCard?.length > 0) {
      if (personCard.length > 0) {
        const { personalityTypes } = personCard[0];
        if (personalityTypes.length > 0) {
          if (personalityTypes.length > 1) {
            let color = personalityTypes.map((item: any) => item.color).join(',');
            setColors(color);
          } else {
            let color = personalityTypes[0].color;
            setColors(`${color}, ${color}`);
          }
        }
      }
    }
  }, [profilePic, personCard]);

  return (
    <Wrapper>
      <Popover
        placement="rightBottom"
        content={
          <Content
            image={image}
            colors={colors}
            fullName={fullName}
            email={email ?? userEmail}
          />
        }
        trigger="click"
        getPopupContainer={(e: HTMLElement) => e}
        onVisibleChange={setPopoverOpen}
      >
        <div
          className="dropdown-user-profile"
          aria-label="Profile picture for menu"
        >
          <Persona border={colors} className="persona-place">
            {image !== '' ? (
              <Image
                className="User_Image"
                image={image}
              />
            ) : (
              <UserIcon />
            )}
          </Persona>
        </div>
      </Popover>
    </Wrapper>);
}

export default AccountPopover;
